import { secrets } from '@chilipiper/config'
import { isCypress, isServiceWorker, store } from '@chilipiper/utils'
import { RoxSetupOptions } from 'rox-browser'
import Rox from './rollout-mock/rolloutMock'

export const isRolloutEnabled =
  !isCypress &&
  !isServiceWorker &&
  process.env.NODE_ENV !== 'development' &&
  !!secrets.rolloutApiKey

const mockRolloutFlags = {
  enableOpenRegistrationSeries: new Rox.Flag(false),
  enableSignature: new Rox.Flag(true),
  enableAddGuestsToCrmSidebar: new Rox.Flag(true),
  enableMaintenance: new Rox.Flag(false),
  enableHopinIntegration: new Rox.Flag(true),
  enableCheckboxDataField: new Rox.Flag(true),
  enableExperimentalDarkMode: new Rox.Flag(true),
  enableNewDistributionReportHistoryTab: new Rox.Flag(true),
  enableGroupLinksInScheduler: new Rox.Flag(true),
  enableHandoffLiveFlowBuilderNew: new Rox.Flag(true),
  enableMultipleAssignmentsReassignModal: new Rox.Flag(true),
  enableOwnershipLinksInScheduler: new Rox.Flag(true),
  chatHideAllTabAndReassignment: new Rox.Flag(false),
  fireNavigation: new Rox.Flag(true),
  forceDisplayInvoiceFlow: new Rox.Flag(true),
  fireTeamsMigration: new Rox.Flag(true),
  enableAdminCenterSettings: new Rox.Flag(false),
  fireAuth: new Rox.Flag(true),
  chatUnreadBadge: new Rox.Flag(true),
  chatBotWorkingHours: new Rox.Flag(true),
  chilicalPreviewModal: new Rox.Flag(false),
  changeBillingPeriod: new Rox.Flag(true),
  notificationSettings: new Rox.Flag(true),
  distroOwnershipFieldsInUpdateOwnership: new Rox.Flag(true),
  brokenIntegrationsBanner: new Rox.Flag(true),
  notifyAllButton: new Rox.Flag(true),
  userDetails: new Rox.Flag(true),
  adminLicense: new Rox.Flag(false),
  chatLogsDetails: new Rox.Flag(true),
  chatConsentFooter: new Rox.RoxString(
    `Chili Piper provides this chat. You agree this chat may be recorded. See Chili Piper's Privacy Statement.`
  ),
  chatConsentFooterLink: new Rox.RoxString('https://www.chilipiper.com/privacy-policy'),
  chatPiperAiNodes: new Rox.Flag(true),
  chatSendTeamsNotification: new Rox.Flag(true),
  outreachIntegration: new Rox.Flag(true),
  navigationLockedByUserLicense: new Rox.Flag(true),
  retryRouting: new Rox.Flag(true),
  enableChatForHubspotTenant: new Rox.Flag(false),
  groupSchedulingLinkHostMeetingLimit: new Rox.Flag(true),
  tenantSlugEditable: new Rox.Flag(true),
  dataFieldCurrencyToNumberMapping: new Rox.Flag(true),
  smartParameters: new Rox.Flag(true),
  distroWorkingHours: new Rox.Flag(true),
  advancedTiebreaks: new Rox.Flag(true),
  enableHubspotEngagementOwner: new Rox.Flag(true),
  distroBulkRetry: new Rox.Flag(true),
  distroVariables: new Rox.Flag(true),
  distroMatchingNode: new Rox.Flag(true),
  ruleOwnershipConditionSearchByFullNameEnabled: new Rox.Flag(true),
  fireMigrationBannerText: new Rox.RoxString('Distro has moved to the Fire workspace!'),
  provisioning: new Rox.Flag(true),
  hubspotRulesStringOwnershipConditions: new Rox.Flag(true),
  personToLeadContactMatching: new Rox.Flag(true),
  usersTableInviteAllButton: new Rox.Flag(true),
  usersTableNotifyButton: new Rox.Flag(true),
  bulkGetTeamsEnabled: new Rox.Flag(true),
  usersManagementTableV2: new Rox.Flag(true),
  conciergeFlowBuilderSearch: new Rox.Flag(false),
  handoffFlowBuilderSearch: new Rox.Flag(true),
  scheduledJobs: new Rox.Flag(true),
  piperSettings: new Rox.Flag(true),
  billingWithNue: new Rox.Flag(false),
  nueInvoicing: new Rox.Flag(true),
  adaSupportEnabled: new Rox.Flag(true),
  distroNotificationsSettings: new Rox.Flag(true),
  distroNotificationNode: new Rox.Flag(true),
  conciergeEnrichment: new Rox.Flag(true),
  reassignFromScheduler: new Rox.Flag(true),
  leadiqIntegration: new Rox.Flag(true),
  apolloIntegration: new Rox.Flag(true),
  canChangeTeamInADistribution: new Rox.Flag(true),
  multipleMatching: new Rox.Flag(true),
  showRequestLicenseButton: new Rox.Flag(true),
  enrichmentIntegrations: new Rox.RoxString(
    JSON.stringify(['LeadIQ', 'Apollo', 'Lusha', 'ZoomInfo'])
  ),
  multiCalendarFeature: new Rox.Flag(true),
  distroDuplicatedInMatching: new Rox.Flag(true),
  automationLogs: new Rox.Flag(true),
  multipleAssignmentsChilical: new Rox.Flag(true),
  secondaryCalendarsInAdmin: new Rox.Flag(true),
  conciergeMultiAssignments: new Rox.Flag(true),
  conciergeSpamChecker: new Rox.Flag(true),
  conciergeOptionalAssignee: new Rox.Flag(true),
  conciergeAnyAttendeeAsHost: new Rox.Flag(true),
  handoffOptionalAssignee: new Rox.Flag(true),
  handoffAnyAttendeeAsHost: new Rox.Flag(true),
  handoffMultiAssignments: new Rox.Flag(true),
  distroUpdateFieldsVariables: new Rox.Flag(true),
  crmActionsMeetingsActivity: new Rox.Flag(true),
  lushaIntegration: new Rox.Flag(true),
  spamChecker: new Rox.Flag(true),
  chiliAgents: new Rox.Flag(true),
  flowOrchestrator: new Rox.Flag(true),
  enableBilling: new Rox.Flag(true),
  customDateOptions: new Rox.Flag(true),
  distroSendToRouter: new Rox.Flag(true),
  authFallback: new Rox.Flag(true),
  disableFireAuthInLegacy: new Rox.Flag(false),
  reportingAgent: new Rox.Flag(true),
  enableSchedulerMultipleAssignment: new Rox.Flag(true),
  meetingPrepAgent: new Rox.Flag(true),
  allowUnpaidInvoices: new Rox.Flag(false),
  chilicalOptionalAssignee: new Rox.Flag(true),
  chilicalAnyAttendeeAsHost: new Rox.Flag(true),
}

const defaultRolloutFlags: typeof mockRolloutFlags = {
  enableOpenRegistrationSeries: new Rox.Flag(false),
  enableSignature: new Rox.Flag(true),
  enableAddGuestsToCrmSidebar: new Rox.Flag(false),
  enableMaintenance: new Rox.Flag(false),
  enableHopinIntegration: new Rox.Flag(false),
  enableChatForHubspotTenant: new Rox.Flag(false),
  enableCheckboxDataField: new Rox.Flag(false),
  enableExperimentalDarkMode: new Rox.Flag(false),
  enableNewDistributionReportHistoryTab: new Rox.Flag(false),
  enableGroupLinksInScheduler: new Rox.Flag(false),
  enableHandoffLiveFlowBuilderNew: new Rox.Flag(false),
  enableOwnershipLinksInScheduler: new Rox.Flag(false),
  enableMultipleAssignmentsReassignModal: new Rox.Flag(false),
  fireNavigation: new Rox.Flag(false),
  forceDisplayInvoiceFlow: new Rox.Flag(false),
  fireTeamsMigration: new Rox.Flag(false),
  enableAdminCenterSettings: new Rox.Flag(false),
  fireAuth: new Rox.Flag(true),
  chatUnreadBadge: new Rox.Flag(false),
  chatBotWorkingHours: new Rox.Flag(false),
  chilicalPreviewModal: new Rox.Flag(false),
  changeBillingPeriod: new Rox.Flag(false),
  notificationSettings: new Rox.Flag(false),
  distroOwnershipFieldsInUpdateOwnership: new Rox.Flag(true),
  brokenIntegrationsBanner: new Rox.Flag(false),
  notifyAllButton: new Rox.Flag(false),
  userDetails: new Rox.Flag(false),
  adminLicense: new Rox.Flag(false),
  chatLogsDetails: new Rox.Flag(false),
  chatConsentFooter: new Rox.RoxString(
    `Chili Piper provides this chat. You agree this chat may be recorded. See Chili Piper's Privacy Statement.`
  ),
  chatConsentFooterLink: new Rox.RoxString('https://www.chilipiper.com/privacy-policy'),
  chatPiperAiNodes: new Rox.Flag(false),
  chatSendTeamsNotification: new Rox.Flag(false),
  outreachIntegration: new Rox.Flag(false),
  navigationLockedByUserLicense: new Rox.Flag(false),
  retryRouting: new Rox.Flag(false),
  groupSchedulingLinkHostMeetingLimit: new Rox.Flag(false),
  tenantSlugEditable: new Rox.Flag(false),
  dataFieldCurrencyToNumberMapping: new Rox.Flag(false),
  smartParameters: new Rox.Flag(false),
  distroWorkingHours: new Rox.Flag(false),
  advancedTiebreaks: new Rox.Flag(false),
  enableHubspotEngagementOwner: new Rox.Flag(false),
  distroBulkRetry: new Rox.Flag(false),
  distroVariables: new Rox.Flag(false),
  distroMatchingNode: new Rox.Flag(false),
  ruleOwnershipConditionSearchByFullNameEnabled: new Rox.Flag(false),
  fireMigrationBannerText: new Rox.RoxString('Distro has moved to the Fire workspace!'),
  provisioning: new Rox.Flag(false),
  hubspotRulesStringOwnershipConditions: new Rox.Flag(false),
  personToLeadContactMatching: new Rox.Flag(false),
  usersTableInviteAllButton: new Rox.Flag(false),
  usersTableNotifyButton: new Rox.Flag(false),
  bulkGetTeamsEnabled: new Rox.Flag(true),
  usersManagementTableV2: new Rox.Flag(false),
  conciergeFlowBuilderSearch: new Rox.Flag(false),
  handoffFlowBuilderSearch: new Rox.Flag(true),
  scheduledJobs: new Rox.Flag(false),
  piperSettings: new Rox.Flag(false),
  billingWithNue: new Rox.Flag(false),
  nueInvoicing: new Rox.Flag(false),
  adaSupportEnabled: new Rox.Flag(false),
  distroNotificationsSettings: new Rox.Flag(false),
  distroNotificationNode: new Rox.Flag(false),
  conciergeEnrichment: new Rox.Flag(false),
  reassignFromScheduler: new Rox.Flag(false),
  leadiqIntegration: new Rox.Flag(false),
  apolloIntegration: new Rox.Flag(false),
  canChangeTeamInADistribution: new Rox.Flag(false),
  multipleMatching: new Rox.Flag(false),
  showRequestLicenseButton: new Rox.Flag(true),
  chatHideAllTabAndReassignment: new Rox.Flag(false),
  enrichmentIntegrations: new Rox.RoxString(JSON.stringify(['LeadIQ', 'Apollo'])),
  multiCalendarFeature: new Rox.Flag(false),
  distroDuplicatedInMatching: new Rox.Flag(false),
  automationLogs: new Rox.Flag(false),
  multipleAssignmentsChilical: new Rox.Flag(false),
  secondaryCalendarsInAdmin: new Rox.Flag(false),
  conciergeMultiAssignments: new Rox.Flag(false),
  conciergeSpamChecker: new Rox.Flag(false),
  conciergeOptionalAssignee: new Rox.Flag(false),
  conciergeAnyAttendeeAsHost: new Rox.Flag(false),
  handoffOptionalAssignee: new Rox.Flag(false),
  handoffAnyAttendeeAsHost: new Rox.Flag(false),
  handoffMultiAssignments: new Rox.Flag(false),
  distroUpdateFieldsVariables: new Rox.Flag(false),
  crmActionsMeetingsActivity: new Rox.Flag(false),
  lushaIntegration: new Rox.Flag(false),
  spamChecker: new Rox.Flag(false),
  chiliAgents: new Rox.Flag(false),
  flowOrchestrator: new Rox.Flag(false),
  enableBilling: new Rox.Flag(true),
  customDateOptions: new Rox.Flag(true),
  distroSendToRouter: new Rox.Flag(false),
  authFallback: new Rox.Flag(true),
  disableFireAuthInLegacy: new Rox.Flag(false),
  reportingAgent: new Rox.Flag(false),
  enableSchedulerMultipleAssignment: new Rox.Flag(false),
  meetingPrepAgent: new Rox.Flag(false),
  allowUnpaidInvoices: new Rox.Flag(false),
  chilicalOptionalAssignee: new Rox.Flag(false),
  chilicalAnyAttendeeAsHost: new Rox.Flag(false),
}

export const isFireAuth = () => rolloutFlags.fireAuth?.isEnabled() ?? false

type Flags = Record<
  keyof typeof mockRolloutFlags,
  { isEnabled(): boolean; getValue(): string | boolean }
>
type MutableFlags = Record<keyof typeof mockRolloutFlags, FlagWrapper>

const rolloutInnerFlags = isRolloutEnabled ? defaultRolloutFlags : mockRolloutFlags

class FlagWrapper {
  private value: boolean | string

  constructor(initialValue: boolean | string) {
    this.value = initialValue
  }

  isEnabled = () => !!this.value

  getValue = () => this.value

  setValue = (value: boolean | string) => {
    this.value = value
  }
}

const initFlags = (): MutableFlags =>
  Object.entries(rolloutInnerFlags).reduce<MutableFlags>((flags, [name, flag]) => {
    if (flag instanceof Rox.Flag) {
      flags[name as keyof typeof mockRolloutFlags] = new FlagWrapper(flag.isEnabled())
    } else {
      flags[name as keyof typeof mockRolloutFlags] = new FlagWrapper(flag.getValue())
    }
    return flags
  }, {} as MutableFlags)

const updateFlags = () =>
  Object.entries(rolloutInnerFlags).forEach(([name, flag]) => {
    if (flag instanceof Rox.Flag) {
      internalFlags[name as keyof typeof mockRolloutFlags].setValue(flag.isEnabled())
    } else {
      internalFlags[name as keyof typeof mockRolloutFlags].setValue(flag.getValue())
    }
  })

const internalFlags = initFlags()

export const rolloutFlags: Partial<Flags> = internalFlags

const registeredNamespaces: Set<string> = new Set()

const rolloutSetup = async (rolloutOptions: RoxSetupOptions, namespace = '') => {
  if (registeredNamespaces.has(namespace)) {
    console.warn(
      'rolloutSetup called for a namespace that has already been registered. Skipping setup.'
    )
    return
  }

  if (isRolloutEnabled) {
    Rox.setCustomStringProperty('hostname', window.location.hostname)

    Rox.register(namespace, rolloutInnerFlags)
    registeredNamespaces.add(namespace)
    await Rox.setup(secrets.rolloutApiKey, rolloutOptions)
  }
}

export const ROLLOUT_EMAIL_LOCALSTORAGE_KEY = 'rollout-email'
export const ROLLOUT_TENANT_ID_LOCALSTORAGE_KEY = 'rollout-tenantId'

export const setRolloutUser = (session: { email?: string; tenantId?: string }): void => {
  if (isRolloutEnabled) {
    if (!store.isFake()) {
      if (session.email) {
        localStorage.setItem(ROLLOUT_EMAIL_LOCALSTORAGE_KEY, session.email)
        Rox.setCustomStringProperty('email', session.email)
      }
      if (session.tenantId) {
        localStorage.setItem(ROLLOUT_TENANT_ID_LOCALSTORAGE_KEY, session.tenantId)
        Rox.setCustomStringProperty('tenantId', session.tenantId)
      }
    }
    Rox.fetch()
  }
}

export type SetUserData = (_session: { email?: string; tenantId: string }) => Promise<void>
/*
 * The idea with this approach was to promisify setting the user data
 * which is a pre-requisite to properly use any feature flag that relies on user data.
 * Basically, we dependency inject the callbackRef object inside of rolloutInit to
 * the asyncSetRolloutUserBuilder which in turn sets the resolve function to the callback
 * of the passed callbackRef object. Resolve function is called once the configurationFetchedHandler
 * is called signalling that the user data is successfully set.
 */
const asyncSetRolloutUserBuilder = (callbackRef: { callback: () => unknown }): SetUserData => {
  return (session: { email?: string; tenantId: string }) =>
    new Promise(res => {
      callbackRef.callback = res
      setRolloutUser(session)
    })
}

const fetchRef = {
  status: '',
}

export const rolloutInit = async (appName: string): Promise<SetUserData> => {
  if (isRolloutEnabled) {
    const callbackRef = {
      callback: () => {},
    }

    const options: RoxSetupOptions = {
      version: '1.2.0',
      configurationFetchedHandler: (fetcherResult: Rox.RoxFetcherResult) => {
        fetchRef.status = fetcherResult.fetcherStatus
        updateFlags()
        callbackRef.callback()
      },
    }
    Rox.setCustomStringProperty('appName', appName)
    await rolloutSetup(options)

    // we have to get from localstorage because rollout saves only unique id for user
    if (!store.isFake()) {
      const userTenantIdCached = localStorage.getItem(ROLLOUT_TENANT_ID_LOCALSTORAGE_KEY) || ''
      const userEmailCached = localStorage.getItem(ROLLOUT_EMAIL_LOCALSTORAGE_KEY) || ''
      setRolloutUser({ email: userEmailCached, tenantId: userTenantIdCached })
    }

    await new Promise(res => {
      const interval = setInterval(() => {
        if (fetchRef.status === 'APPLIED_FROM_NETWORK') {
          clearInterval(interval)
          res(undefined)
        }
      }, 100)
    })

    return asyncSetRolloutUserBuilder(callbackRef)
  }
  return () => Promise.resolve()
}
